import { useSyncExternalStore } from 'react';
import { AuthState, BaseAuthenticationService } from './BaseAuthenticationService';

export function createUseAuthState<S extends AuthState<unknown>>(auth: BaseAuthenticationService<S>): () => S {
  return function useAuthState(): S {
    const state = useSyncExternalStore(auth.subscribe, auth.getSnapshot);
    return state;
  };
}
